export const CRE_SOS_SET_SIDEBAR = 'CRE_SOS_SET_SIDEBAR';
export const CRE_SOS_SET_VIEW = 'CRE_SOS_SET_VIEW';
export const CRE_SOS_SET_FILTERS = 'CRE_SOS_SET_FILTERS';
export const CRE_SOS_SET_FILTERS_DATA = 'CRE_SOS_SET_FILTERS_DATA';
export const CRE_SOS_SET_FILTERS_LOADING = 'CRE_SOS_SET_FILTERS_LOADING';
export const CRE_SOS_SET_FILTERS_SUMMARY = 'CRE_SOS_SET_FILTERS_SUMMARY';
export const CRE_SOS_SET_DATA = 'CRE_SOS_SET_DATA';
export const CRE_SOS_SET_LOADING = 'CRE_SOS_SET_LOADING';
export const CRE_SOS_SET_SITES_DATA = 'CRE_SOS_SET_SITES_DATA';
export const CRE_SOS_SET_SITES_LOADING = 'CRE_SOS_SET_SITES_LOADING';
export const CRE_SOS_SET_AGGREGATE_CHART_DATA =
  'CRE_SOS_SET_AGGREGATE_CHART_DATA';
export const CRE_SOS_SET_AGGREGATE_CHART_DATA_LOADING =
  'CRE_SOS_SET_AGGREGATE_CHART_DATA_LOADING';
